import { memoize } from 'lodash'

import { APP_ENTITIES_PERMISSIONS } from '@/utils/permissions'

export const PROGRESS_HISTORY_PERMISSIONS = {
  REMOVE: APP_ENTITIES_PERMISSIONS.REMOVE
}

const { REMOVE } = PROGRESS_HISTORY_PERMISSIONS

const permissionsCacheKeyResolver = progressItem => {
  return progressItem.permissions.join('|')
}

export const currentUserCanDeleteProgressHistory = memoize(progressItem => {
  return progressItem.permissions.includes(REMOVE)
}, permissionsCacheKeyResolver)
